export default (theme) => ({
    root: {
        '& [class*="InputWrapper__Label"]': {
            paddingTop: '13px !important',
        },
    },
    slider: {
        width: 'calc(100% - 15px)',
        minHeight: 50,
        margin: 'auto',
        position: 'relative',
        padding: '25px 0',
        borderRadius: 6,
        touchAction: 'none',
        boxSizing: 'border-box',
        cursor: 'pointer',
    },
    rail: {
        boxSizing: 'border-box',
        position: 'absolute',
        width: '100%',
        backgroundColor: theme.colors.grey[100],
        height: 4,
        borderRadius: 6,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    track: {
        boxSizing: 'border-box',
        position: 'absolute',
        height: 4,
        borderRadius: 6,
        backgroundColor: theme.colors.actionMajor[500],
        top: '50%',
        transform: 'translateY(-50%)',
    },
    handleContainer: {
        position: 'relative',
    },
    label: {
        position: 'absolute',
        minWidth: 15,
        top: -30,
        transform: 'translateX(-50%)',
        textAlign: 'center',
        color: theme.colors.grey[500],
        fontSize: 12,
        fontFamily: theme.typography.fontFamily,
        letterSpacing: theme.typography.letterSpacing,
        pointerEvents: 'none',
    },
    handle: {
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 16,
        height: 16,
        cursor: 'grab',
        borderRadius: '50%',
        border: '0',
        backgroundColor: theme.colors.actionMajor[500],
        MsTouchAction: 'pan-x',
        touchAction: 'pan-x',
        '&:focus': {
            outline: 'none',
        },
    },
    handleActive: {
        cursor: 'grabbing',
    },
    isReadOnly: {
        cursor: 'default',
        '& $handle': {
            backgroundColor: theme.colors.grey[200],
            cursor: 'default',
        },
        '& $track': {
            backgroundColor: theme.colors.grey[200],
        },
    },
});
